import * as yup from "yup";

export const EventInformationSchema = yup.object().shape({
	eventDate: yup.string().required("Event date is required"),
	eventTime: yup.string().required("Please select event time slot"),
	numberOfGuests: yup.string().required("Number of guests is required"),
});

export const eventInformationState = {
	eventDate: "",
	eventTime: "",
	numberOfGuests: "",
	slot: {
		slotId: "",
		eventStartTime: "",
		eventEndTime: "",
	},
};
